// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u2yT","option":"styles_option__flCMw","active":"styles_active__3aRdo"};